import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=1215e3b4&scoped=true"
import script from "./plain.vue?vue&type=script&lang=ts"
export * from "./plain.vue?vue&type=script&lang=ts"
import style0 from "./plain.vue?vue&type=style&index=0&id=1215e3b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215e3b4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VMain,VOverlay,VProgressCircular,VSnackbar})


/* vuetify-loader */
import installDirectives from "!../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1215e3b4')) {
      api.createRecord('1215e3b4', component.options)
    } else {
      api.reload('1215e3b4', component.options)
    }
    module.hot.accept("./plain.vue?vue&type=template&id=1215e3b4&scoped=true", function () {
      api.rerender('1215e3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/plain.vue"
export default component.exports